module.exports = __webpack_public_path__ + "assets/img/36_576_big.08f74b5f.jpg";